import type { EventType } from "../../../../schemas/generated/ts/watch_events";

// Kinds severe enough to get the risk treatment (status-dot risk variant)
// in the dashboard activity feed. Mirrors DISTRESS_KINDS in the worker's
// email copy (portal/worker/src/watch/email_render.ts) — kept as an
// accepted small duplication (both break typecheck independently on a
// kind renamed/removed in schemas/events.yaml via the `satisfies` below,
// so the two lists can't silently drift apart).
export const DISTRESS_KINDS = [
  "insolvency.case",
  "company.status_changed",
  "status.administration",
  "status.liquidation",
  "status.cva",
  "status.receivership",
  "status.dissolved",
  "status.strike_off_proposed",
  "filing.accounts_overdue",
  "filing.cs_lapsed",
  "accounts.negative_equity",
  "accounts.runway_breach",
  "charges.burst",
  "composite.distress_cluster",
] as const satisfies readonly EventType[];

const DISTRESS_SET: ReadonlySet<string> = new Set(DISTRESS_KINDS);

export function isDistressKind(kind: string): boolean {
  return DISTRESS_SET.has(kind);
}
